import React from 'react';
import { Icon, Toggle } from '@pwc/pwc-deals-ui';
import { useSelector } from 'react-redux';
import { getUserRole } from 'common/redux/security/loggedInUser/loggedInUserSlice';
import { USER_TYPE_CLASSES } from 'common/constants/General';
import './ProjectRoleUserPill.scss';

export const ProjectRoleUserPill = ({
  user,
  showEmail,
  onClearClick,
  onTogglePending = undefined,
}) => {
  const userRole = useSelector(getUserRole);
  const userTypeClass = USER_TYPE_CLASSES[userRole] || '';

  const withToggleCLass = onTogglePending ? 'with-toggle' : '';
  const pendingClass = user.wasPending || user.newlyAdded ? 'pending' : '';
  const pendingApprovedClass =
    user.wasPending && !user.pendingApproval ? 'pending-approved' : '';
  const pendingApprovalClass = user.pendingApproval ? 'pending-approval' : '';
  const iconColorClass =
    userTypeClass === 'pwc-user' && !pendingClass ? 'icon-white' : 'icon-black';
  return (
    <div
      className={`project-role-user-pill ${userTypeClass} ${pendingClass} ${withToggleCLass} ${pendingApprovalClass} ${pendingApprovedClass}`}
      data-testid={`project-role-user-pill-${user.pillId}`}
    >
      <Icon
        name={user.pendingApproval ? 'clock' : 'avatar'}
        height={16}
        className={`fill ${iconColorClass}`}
      />
      {onTogglePending ? (
        <Toggle
          checked={!user.pendingApproval}
          onClick={onTogglePending}
          name={`project-role-user-pill-toggle-${user.pillId}`}
          dataTestId={`project-role-user-pill-toggle-${user.pillId}`}
        />
      ) : null}
      <span className="pill-text">
        {`${user.firstName} ${user.lastName}${
          showEmail ? ` / ${user.email}` : ''
        }`}
      </span>
      {onClearClick && (
        <button
          type="button"
          onClick={onClearClick}
          data-testid={`project-role-user-pill-x-${user.pillId}`}
        >
          <Icon
            name="close"
            className={`fill ${iconColorClass}`}
            height={11}
            data-testid="close-icon"
          />
        </button>
      )}
    </div>
  );
};

export default ProjectRoleUserPill;
